import React, { Component } from 'react';
import { renderPanelHeader } from './common'
import { Field, reduxForm } from 'redux-form';
import { Button, Form, Alert, Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FormActions, Select, Input } from '../../../common/components/formControls';
import validators from '../../../common/services/validators';
import { loadData } from './common'
import TermsDropdownList from '../../terms/DropdownList';
import ReduxBlockUi from 'react-block-ui/redux';
import { WEEKLY_PROGRAMS_COPY_REQUEST, WEEKLY_PROGRAMS_COPY_FAILURE } from '../actions';

class CopyWeeklyProgram extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		loadData(this.props);
	}

	render() {
		const { t, center, term, terms, error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded } = this.props;
		const header = renderPanelHeader(t('WeeklyProgram_CopyWeeklyProgram'), center, term);
		return (
			<Panel>
				<Panel.Heading>{header}</Panel.Heading>
				<Panel.Body>
					<ReduxBlockUi block={WEEKLY_PROGRAMS_COPY_REQUEST} unblock={WEEKLY_PROGRAMS_COPY_FAILURE}>
						<Form horizontal onSubmit={handleSubmit}>
							{error && <Alert bsStyle='danger'>{error}</Alert>}
							{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
							<TermsDropdownList render='field' name='fromTermId' horizontal required label={t('WeeklyProgram_FromTerm')} emptyLabel={t('WeeklyProgram_ChooseTerm')} centerId={center && center.id} data={terms} validate={[validators.required]} />
							<TermsDropdownList render='field' name='toTermId' horizontal required label={t('WeeklyProgram_ToTerm')} emptyLabel={t('WeeklyProgram_ChooseTerm')} centerId={center && center.id} data={terms} validate={[validators.required]} />
							<div className='invisible'>
								<Field name='centerId' component={Input} type='hidden' />
							</div>
							<FormActions horizontal>
								<Link to='/weeklyProgram' className='btn btn-default'>{t('Common_BackToList')}</Link>
								<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Copy')}</Button>
							</FormActions>
						</Form>
					</ReduxBlockUi>
				</Panel.Body>
			</Panel>
		);
	}
}

export default reduxForm({ form: 'weeklyProgramCopy' })(CopyWeeklyProgram);